module.exports = __webpack_public_path__ + "img/home-arguments-nosleep.12e1d679.svg";